export const convertToLocal = (epoch, detailed, separate) => {
    var d = new Date(0);
    d.setUTCSeconds(epoch);

    if (!detailed) return d.toLocaleDateString();
    if (separate) {
        return [d.toLocaleDateString(), d.toLocaleTimeString()];
    } else {
        return d.toLocaleDateString() + " at " + d.toLocaleTimeString();
    }
};

export const convertIntuitiveTime = (epoch) => {
    const now = new Date();
    const date = new Date(epoch * 1000);

    const nowDay = now.toDateString();
    const dateDay = date.toDateString();

    const timeString = date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
    });

    if (nowDay === dateDay) {
        return timeString;
    }

    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
    const yesterdayDay = yesterday.toDateString();

    if (dateDay === yesterdayDay) {
        return `Yesterday at ${timeString}`;
    }

    const dateString = date.toLocaleDateString();
    return `${dateString} ${timeString}`;
};